import { RadioButtons } from "Components/Shared/Inputs/Form/RadioButtons";
import { Resources, useResource } from "Translations/Resources";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

const convertToBoolean = (value: string) => value === "true";

type Props<
  TFormType extends FieldValues,
  TransformedFieldValues = TFormType,
> = {
  name: FieldPath<TFormType>;
  control: Control<TFormType, unknown, TransformedFieldValues>;
  label?: string;
  row?: boolean;
  justifyContent?: "center" | "flex-start";
  isInitiallyUndefined?: boolean;
};

export const BooleanRadioChoice = <T extends object, V extends object>({
  control,
  name,
  label,
  row = true,
  justifyContent = "center",
  isInitiallyUndefined = false,
}: Props<T, V>) => {
  const { t } = useResource();

  //Nice to have, names could come from props if we need different texts than Ano/Ne
  const options = [
    {
      id: 1,
      code: "true",
      name: t(Resources.Common.Yes),
    },
    {
      id: 0,
      code: "false",
      name: t(Resources.Common.No),
    },
  ];

  return (
    <RadioButtons
      isInitiallyUndefined={isInitiallyUndefined}
      onChangeValueTransform={(value) => convertToBoolean(value)}
      name={name}
      label={label}
      justifyContent={justifyContent}
      codeList={options}
      control={control}
      row={row}
    />
  );
};
